(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5393],{

/***/ 1093:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airdrop",
      function () {
        return __webpack_require__(28164);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ airdrop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(25349);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(67539);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./src/views/Page.tsx
var Page = __webpack_require__(49438);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/service/service.ts + 1 modules
var service = __webpack_require__(36141);
// EXTERNAL MODULE: ./src/service/chainUtils.ts
var chainUtils = __webpack_require__(99635);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var localization_src = __webpack_require__(65208);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/views/Activity/index.tsx
/* eslint-disable */ 


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  // width: 100%;\n  margin-bottom: 20px;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: 600;\n  // position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  img {\n    width: ",
        ";\n    height: auto;\n    // position: relative;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100px;\n  height: auto;\n  position: absolute;\n  top: 10%;\n  left: -20%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100px;\n  height: auto;\n  position: absolute;\n  top: 40%;\n  right: -20%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  height: 35px;\n  padding: 5px 20px;\n  font-size: 14px;\n  border-radius: 20px 5px 5px 0;\n  background-color: #fde16f;\n  border: 1px solid #14162a;\n  box-shadow: 3px 3px 1px #000;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: bold;\n  margin-left: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  // line-height: ",
        ";\n  height: 22px;\n  font-weight: bold;\n  display: inline-block;\n  position: relative;\n  z-index: 4;\n  // border-bottom: ",
        ";\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: ",
        ";\n    height: 22px;\n    left: 0;\n    width: 100%;\n    z-index: -1;\n    height: 10px;\n    background: #fde16f;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: ",
        ";\n  margin-bottom: 40px;\n  flex-direction: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 40px;\n  & > li {\n    line-height: 20px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fde16f;\n  border-radius: 4px;\n  font-size: 12px;\n  padding: 8px 10px;\n  cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  margin: 20px 0;\n  padding: 0;\n  li {\n    margin: 0;\n    padding: 0;\n    line-height: ",
        ";\n    font-size: ",
        ";\n  }\n  li::before {\n    content: '•';\n    margin-right: 4px;\n  }\n  li::marker {\n    font-size: 12px;\n  }\n  div {\n    white-space: pre-line;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #14162a;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: #fde16f;\n  font-weight: bold;\n  display: flex;\n  background: #14162a;\n  border-radius: 8px 8px 0px 0px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  padding: 10px 0;\n  minheight: 50px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  border-right: 1px solid #8c8c8c;\n  &:last-child {\n    border-right: none;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  display: flex;\n  border-bottom: 1px solid #8c8c8c;\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  border-right: 1px solid #8c8c8c;\n  flex: 1;\n  minheight: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 15px 0;\n  &:last-child {\n    border-right: none;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  margin-bottom: 20px;\n  position: relative;\n  z-index: 10000;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: rgba(255, 255, 255, 1);\n  border-radius: 16px;\n  padding: ",
        ";\n  margin-bottom: 20px;\n  width: 100%;\n  position: relative;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}












var Titles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-0"
})(_templateObject(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "100%" : "1000px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "20px" : "30px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "24px" : "35px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "150px" : "140px";
});
var AdLeftImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-aafc42c0-1"
})(_templateObject1());
var AdRightImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-aafc42c0-2"
})(_templateObject2());
var Pointer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-aafc42c0-3"
})(_templateObject3());
var BigTit = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-aafc42c0-4"
})(_templateObject4(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "16px" : "26px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "20px" : "30px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "0px" : "20px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "20px" : "0px";
});
var SmallTit = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-aafc42c0-5"
})(_templateObject5(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "16px" : "22px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "12px" : "14px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "5px solid #fde16f;" : "10px solid #fde16f;";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "-6px" : "-6px";
});
var FlexJu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-6"
})(_templateObject6(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "flex-start" : "center";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "column" : "row";
});
var Boxs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-7"
})(_templateObject7());
var More = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-8"
})(_templateObject8());
var BulletList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-aafc42c0-9"
})(_templateObject9(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "18px" : "20px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "14px" : "16px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "14px" : "16px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "18px" : "20px";
});
var Tables = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-10"
})(_templateObject10());
var Headers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-11"
})(_templateObject11(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "13px" : "16px";
});
var HeadersText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-12"
})(_templateObject12());
var Bodys = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-13"
})(_templateObject13());
var BodysText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-14"
})(_templateObject14(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "12px" : "14px";
});
var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-15"
})(_templateObject15(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "100%" : "1000px";
});
// const WrapBox = styled.div<{ isMobile?: boolean }>`
//   background-color: #fff;
//   border-radius: 16px;
//   padding: ${({ isMobile }) => (isMobile ? '20px' : '40px')};
//   /* width: 800px; */
//   margin-bottom: 20px;
//   width: 100%;
// `
var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aafc42c0-16"
})(_templateObject16(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "20px" : "40px";
});
function AirDrop() {
    var ref = (0,localization_src/* useTranslation */.$G)(), t = ref.t, _currentLanguage = ref.currentLanguage, langCode = _currentLanguage.code;
    var router = (0,next_router.useRouter)();
    // const parsedQueryChainId = Number(router.query.chainId)
    // const chainId = parsedQueryChainId
    // const { chainId } = useActiveWeb3React()
    var account = (0,src/* useWeb3React */.Ge)().account;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var ref1 = (0,react.useState)(0), myRank = ref1[0], setMyRank = ref1[1];
    (0,react.useEffect)(function() {
        // if (!chainId) return
        var ref = (0,chainUtils/* default */.Z)(), baseURL = ref.baseURL, chainid = ref.chainid;
        var params = {
            pairId: "0x2dfada2212e534b7e234fb877dca4ddcaef049b7"
        };
        // if (account) {
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, data, code;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,service/* getTokenHoldersSnapshotRank */.Kk)(params, {
                                    baseURL: baseURL,
                                    chainid: chainid,
                                    account: account
                                })
                            ];
                        case 1:
                            ref = _state.sent(), data = ref.data, code = ref.code;
                            if (!code) {
                                // setAirList(data)
                                setMyRank(data.rank);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        fetch();
    // }
    }, [
        account
    ]);
    // 0x6a46efcb54feb6a920f607943e1c35425095ec0e5ac49246ed66fd8d0861fa67 hash
    // const handleClaim = async () => {
    //   setAirdropState({ attemptingTxn: true, airdropErrorMessage: undefined, txHash: undefined })
    //   // const estimate = airdropContract.estimateGas.claim
    //   const method = airdropContract.claim
    //   console.log(chainId, 'chainId')
    //   console.log(210000, 'gasLimit')
    //   console.log(gasPrice, 'gasPrice')
    //   await method({
    //     // gasLimit: calculateGasMargin(estimatedGasLimit),
    //     gasLimit: 210000,
    //     gasPrice,
    //   })
    //     .then((response) => {
    //       setAirdropState({ attemptingTxn: false, airdropErrorMessage: undefined, txHash: response.hash })
    //       setTimeout(() => {
    //         getData(account)
    //       }, 5000)
    //     })
    //     .catch((err) => {
    //       if (err && err.code !== 4001) {
    //         setAirdropState({
    //           attemptingTxn: false,
    //           airdropErrorMessage: err.message,
    //           txHash: undefined,
    //         })
    //       }
    //     })
    // }
    //   await estimate()
    //     .then((estimatedGasLimit) => {
    //       console.log(calculateGasMargin(estimatedGasLimit), 'calculateGasMargin(estimatedGasLimit)')
    //       method({
    // gasLimit: calculateGasMargin(estimatedGasLimit),
    //         gasPrice,
    //       }).then((response) => {
    //         setAirdropState({ attemptingTxn: false, airdropErrorMessage: undefined, txHash: response.hash })
    //         setTimeout(() => {
    //           getData(account)
    //         }, 5000)
    //       })
    //       console.log(calculateGasMargin(estimatedGasLimit), 'calculateGasMargin(estimatedGasLimit)')
    //       console.log(gasPrice, 'gasPrice')
    //     }).catch((err) => {
    //       // console.log(calculateGasMargin(estimatedGasLimit), 'calculateGasMargin(estimatedGasLimit)')
    //       console.log(gasPrice, 'gasPrice')
    //       console.log(err, 'err')
    //       if (err && err.code !== 4001) {
    //         setAirdropState({
    //           attemptingTxn: false,
    //           airdropErrorMessage: err.message,
    //           txHash: undefined,
    //         })
    //       }
    //     })
    // }
    // 领取xxxNOAH
    // const pendingText = `${t('noah237')}${claimableAmounts} NOAH`
    // const [onPresentResultModal] = useModal(
    //   <ResultModal
    //     attemptingTxn={attemptingTxn}
    //     hash={txHash}
    //     airdropErrorMessage={airdropErrorMessage}
    //     claimableAmounts={claimableAmounts}
    //     pendingText={pendingText}
    //   />,
    //   false,
    //   true,
    //   'airdropModal',
    // )
    // let jumpHref = 'https://noah-finance.gitbook.io/noah/noah-airdrop-rules-2023-05-15'
    // if (langCode === 'zh-tw') {
    //   jumpHref = 'https://noah-finance.gitbook.io/noah/v/fan-ti/noah-kong-tou-gui-ze-20230515'
    // } else if (langCode === 'ko') {
    //   jumpHref = 'https://noah-finance.gitbook.io/noah/v/undefined/2023-05-15'
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        backImg: true,
        isMobile: isMobile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Titles, {
                isMobile: isMobile,
                children: [
                    t("noah486"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/activity/bg.png",
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrap, {
                isMobile: isMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
                    isMobile: isMobile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexJu, {
                            isMobile: isMobile,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pointer, {
                                    children: t("noah488")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BigTit, {
                                    isMobile: isMobile,
                                    children: t("noah489")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Boxs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTit, {
                                    isMobile: isMobile,
                                    children: t("noah490")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                    isMobile: isMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("noah491")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        color: "#DD8A00",
                                        fontSize: "13px",
                                        lineHeight: "18px",
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        return window.open("https://explorer.evm.eosnetwork.com/address/0x33B57dC70014FD7AA6e1ed3080eeD2B619632B8e");
                                    },
                                    children: t("noah487")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Boxs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTit, {
                                    isMobile: isMobile,
                                    children: t("noah492")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                    isMobile: isMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("noah493")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Boxs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTit, {
                                    isMobile: isMobile,
                                    children: t("noah494")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                    isMobile: isMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("noah495")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tables, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Headers, {
                                            isMobile: isMobile,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadersText, {
                                                    children: t("noah514")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadersText, {
                                                    children: t("noah496")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadersText, {
                                                    children: t("noah497")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah498")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "3000 NOAH"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: "/"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah499")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "6000 NOAH"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("> 600,000 USDT")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah500")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "10000 NOAH"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t(">1,000,000 USDT")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Boxs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTit, {
                                            isMobile: isMobile,
                                            style: {
                                                height: "22px"
                                            },
                                            children: t("noah501")
                                        }),
                                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                account && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        marginRight: "20px",
                                                        fontSize: "14px"
                                                    },
                                                    children: [
                                                        t("noah530"),
                                                        ": ",
                                                        myRank
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(More, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/airdrop/more",
                                                        children: t("noah535")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        marginTop: "20px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-end"
                                    },
                                    children: [
                                        account && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                marginRight: "20px",
                                                fontSize: "14px"
                                            },
                                            children: [
                                                t("noah530"),
                                                ": ",
                                                myRank
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(More, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/airdrop/more",
                                                children: t("noah535")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                    isMobile: isMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("noah502")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tables, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Headers, {
                                            isMobile: isMobile,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadersText, {
                                                    children: t("noah503")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadersText, {
                                                    children: t("noah504")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadersText, {
                                                    children: t("noah505")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: "20%"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "2000"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: "15%"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "1500"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: "13%"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "1300"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: "12%"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "1200"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: "10%"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "1000"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("6-10")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: "30%"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "600"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Boxs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTit, {
                                    isMobile: isMobile,
                                    children: t("noah506")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                    isMobile: isMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: t("noah507")
                                    })
                                })
                            ]
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdLeftImg, {
                            src: "/images/activity/left.png",
                            alt: ""
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdRightImg, {
                            src: "/images/activity/right.png",
                            alt: ""
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrap, {
                isMobile: isMobile,
                style: {
                    marginBottom: "200px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
                    isMobile: isMobile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexJu, {
                            isMobile: isMobile,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pointer, {
                                    children: t("noah508")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BigTit, {
                                    isMobile: isMobile,
                                    children: t("noah509")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Boxs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTit, {
                                    isMobile: isMobile,
                                    children: t("noah510")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                    isMobile: isMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("noah511")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Boxs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTit, {
                                    isMobile: isMobile,
                                    children: t("noah492")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                    isMobile: isMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("noah512")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Boxs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTit, {
                                    isMobile: isMobile,
                                    children: t("noah513")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tables, {
                                    style: {
                                        marginTop: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Headers, {
                                            isMobile: isMobile,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadersText, {
                                                    children: t("noah514")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeadersText, {
                                                    children: [
                                                        t("noah517"),
                                                        t("noah529")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadersText, {
                                                    children: t("noah523")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah515")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah518")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "3"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah516")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah519")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "5"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah516")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah520")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "15"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah527")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah521")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "5"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bodys, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah528")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    children: t("noah522")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodysText, {
                                                    isMobile: isMobile,
                                                    style: {
                                                        color: "#EE990B",
                                                        fontWeight: "bold"
                                                    },
                                                    children: "10"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Boxs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTit, {
                                    isMobile: isMobile,
                                    children: t("noah524")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                    isMobile: isMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: t("noah526")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/airdrop/index.tsx


var AirDropPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AirDrop, {});
};
AirDropPage.Layout = AirDropPage;
// AirDropPage.mp = false
/* harmony default export */ var airdrop = (AirDropPage);


/***/ }),

/***/ 49438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94589);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4318);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68274);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: ",
        ";\n  min-height: ",
        ";\n  background: ",
        ";\n  min-height: calc(100vh - 64px);\n  ",
        " {\n    background-size: auto;\n    min-height: 100vh;\n  }\n\n  ",
        " {\n    padding: ",
        ";\n    padding-bottom: 0;\n    /* height: ",
        "; */\n  }\n\n  ",
        " {\n    padding: ",
        ";\n    padding-bottom: 0;\n    /* min-height: ",
        "; */\n    min-height: calc(100vh - 64px);\n  }\n\n  position: relative;\n  .img-cls {\n    display: block;\n    width: 80px;\n    position: fixed;\n  }\n  .img-left {\n    left: 3%;\n    top: 30%;\n  }\n  .img-right {\n    right: 3%;\n    top: 30%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledPage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3101ac26-0"
})(_templateObject(), function(param) {
    var $removePadding = param.$removePadding;
    return $removePadding ? "0" : "64px 16px 16px 16px";
}, function(param) {
    var $noMinHeight = param.$noMinHeight;
    return $noMinHeight ? "initial" : "calc(100vh - 64px)";
}, function(param) {
    var theme = param.theme;
    return theme.colors.gradients.bubblegum;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var $removePadding = param.$removePadding;
    return $removePadding ? "0" : "72px 24px 24px 24px";
}, function(param) {
    var $removePadding = param.$removePadding;
    return $removePadding ? "100%" : "100vh";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var $removePadding = param.$removePadding;
    return $removePadding ? "0" : "30px 32px 32px 32px";
}, function(param) {
    var $noMinHeight = param.$noMinHeight;
    return $noMinHeight ? "initial" : "calc(100vh - 100px)";
});
var Page = function(_param) {
    var children = _param.children, _removePadding = _param.removePadding, removePadding = _removePadding === void 0 ? false : _removePadding, _hideFooterOnDesktop = _param.hideFooterOnDesktop, hideFooterOnDesktop = _hideFooterOnDesktop === void 0 ? false : _hideFooterOnDesktop, _noMinHeight = _param.noMinHeight, noMinHeight = _noMinHeight === void 0 ? false : _noMinHeight, _helpUrl = _param.helpUrl, helpUrl = _helpUrl === void 0 ? config_constants__WEBPACK_IMPORTED_MODULE_2__/* .EXCHANGE_DOCS_URLS */ .SO : _helpUrl, _backImg = _param.backImg, backImg = _backImg === void 0 ? false : _backImg, _isMobile = _param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _footer = _param.footer, footer = _footer === void 0 ? true : _footer, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "removePadding",
        "hideFooterOnDesktop",
        "noMinHeight",
        "helpUrl",
        "backImg",
        "isMobile",
        "footer"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPage, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            $removePadding: removePadding,
            $noMinHeight: noMinHeight
        }, props), {
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    flexGrow: 1
                })
            ]
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(1093); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);